export default {
  // Navigation
  'nav.timer': 'タイマー',
  'nav.stopwatch': 'ストップウォッチ',
  'nav.worldclock': '世界時計',
  'nav.timestamp': 'タイムスタンプ',
  'nav.home': 'ホーム',

  // Common buttons and actions
  'button.start': '開始',
  'button.pause': '一時停止',
  'button.stop': '停止',
  'button.reset': 'リセット',
  'button.ok': 'OK',
  'button.cancel': 'キャンセル',
  'button.close': '閉じる',
  'button.save': '保存',
  'button.delete': '削除',
  'button.edit': '編集',
  'button.back': '戻る',
  'button.next': '次へ',
  'button.previous': '前へ',
  'button.submit': '送信',
  'button.confirm': '確認',
  'button.convert': '変換',
  'button.copy': 'コピー',
  'button.copied': 'コピーしました！',
  'button.now': '現在',
  'button.clear': 'クリア',

  // Common labels
  'label.hours': '時間',
  'label.minutes': '分',
  'label.seconds': '秒',
  'label.milliseconds': 'ミリ秒',
  'label.minute': '分',
  'label.second': '秒',
  'label.sound': 'サウンド',
  'label.soundAlert': 'サウンド',
  'label.fullscreen': '全画面',
  'label.language': '言語',
  'label.selectLanguage': '言語を選択',
  'label.languageSelectorInfo': '現在 {{count}} 言語に対応しています。上記のオプションからお好みの言語を選択してください。',

  // Common messages
  'message.timerComplete': 'タイマー完了！',
  'message.timerCompleteDesc': 'タイマーが終了しました',
  'message.timerCompleteBody': 'カウントダウンタイマーが終了しました！',
  'message.stopwatchStarted': 'ストップウォッチ開始',
  'message.stopwatchStartedDesc': 'ストップウォッチの計測を開始しました',
  'message.stopwatchStopped': 'ストップウォッチ停止',
  'message.stopwatchStoppedDesc': 'ストップウォッチの計測を一時停止しました',
  'message.stopwatchReset': 'ストップウォッチリセット',
  'message.stopwatchResetDesc': 'ストップウォッチをゼロにリセットしました',
  'message.notificationPermission': 'タイマー終了時に通知を受け取るには、通知を許可してください',
  'message.clickToEdit': '時刻の数字をクリックして直接編集できます',
  'message.addHours': '+ 時間を追加',
  'message.escToExit': 'ESCキーで全画面を終了',
  'message.timeRemaining': '残り{{minutes}}分{{seconds}}秒',
  'message.minutesRemaining': '残り{{minutes}}分',
  'message.secondsRemaining': '残り{{seconds}}秒',
  'message.stopwatchTimeElapsed': '経過時間{{minutes}}分{{seconds}}秒',
  'message.stopwatchMinutesElapsed': '経過時間{{minutes}}分',
  'message.stopwatchSecondsElapsed': '経過時間{{seconds}}秒',
  'message.invalidTimestamp': '無効なタイムスタンプです',
  'message.invalidDateTime': '無効な日時です',
  'message.conversionError': '変換エラー',

  // Time units
  'time.am': '午前',
  'time.pm': '午後',
  'time.now': '現在',
  'time.today': '今日',
  'time.yesterday': '昨日',
  'time.tomorrow': '明日',

  // Common errors
  'error.pageNotFound': 'ページが見つかりません',
  'error.somethingWrong': '問題が発生しました',
  'error.tryAgain': '後でもう一度お試しください',

  // Footer
  'footer.about': 'timer.todayについて',
  'footer.aboutDesc': 'timer.todayは3つの主要機能を提供するプロフェッショナルなオンラインタイミングツールプラットフォームです：',
  'footer.timerDesc': '分・時間設定に対応したカスタマイズ可能なカウントダウンツール。作業の集中、料理のタイミング、学習管理などに最適です。サウンドアラートとデスクトップ通知機能付き。',
  'footer.stopwatchDesc': 'ミリ秒精度の高精度タイミングツール。スポーツトレーニング、料理作業、試験練習など、正確なタイミングが必要なシーンに適しています。',
  'footer.worldClockDesc': '世界主要都市の時刻をリアルタイム表示。インテリジェントなタイムゾーン計算により、国際ビジネスコミュニケーションやタイムゾーン間のコラボレーションを円滑にします。',
  'footer.timestampDesc': 'Unixタイムスタンプコンバーター。タイムスタンプと日時の双方向変換に対応し、秒とミリ秒の両フォーマットをサポートします。',
  'footer.termsOfService': '利用規約',
  'footer.privacy': 'プライバシー',
  'footer.contactUs': 'お問い合わせ',
  'footer.changeLanguage': '言語を変更',
  'footer.moreLanguage': 'その他の言語',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30秒',
  'quick.add1min': '+1分',
  'quick.add5min': '+5分',
  'quick.add10min': '+10分',
  'quick.add30min': '+30分',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}}分タイマー',
  'breadcrumb.timer': 'タイマー',
  'breadcrumb.stopwatch': 'ストップウォッチ',
  'breadcrumb.worldClock': '世界時計',
  'breadcrumb.termsOfService': '利用規約',
};
